import React, { useMemo } from "react";
import { Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";

import HeaderTitle from "../../../components/common/HeaderTitle/HeaderTitle";
import InfoLabel from "../../../components/common/InfoLabel/InfoLabel";
import styles from "../../VendorsTabs/InvoiceProcess/InvoiceProcess.module.css";

const MyProfile = () => {
  const loginData = useSelector((state) => state.loginData.value);

  const displayName = useMemo(() => {
    return (
      loginData?.userName ||
      loginData?.name ||
      loginData?.username ||
      loginData?.user?.userName ||
      loginData?.user?.name ||
      loginData?.user?.username ||
      loginData?.user?.first_name ||
      "-"
    );
  }, [loginData]);

  const displayEmail = useMemo(() => {
    return loginData?.email || loginData?.user?.email || "-";
  }, [loginData]);

  return (
    <Box className={styles.container}>
      <Box className={styles.header}>
        <HeaderTitle titleText="My Profile" />
      </Box>

      <Box
        sx={{
          background: "#fff",
          border: "1px solid #e2e8f0",
          borderRadius: "14px",
          padding: 2,
          fontFamily: "gilroyMedium",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          <InfoLabel
            label="User Name"
            value={displayName}
            isLoading={false}
            size="320px"
            maxLength={120}
          />
          <InfoLabel
            label="Email Address"
            value={displayEmail}
            isLoading={false}
            size="360px"
            maxLength={120}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default MyProfile;
